import { request } from '@/api/request'

export const getFreeSongRank = async () => {
  const { data } = await request.get('/webapi/song/rank/free')

  return data.value
}

export const getPaidSongRank = async () => {
  const { data } = await request.get('/webapi/song/rank/paid')

  return data.value
}

export const getShowcaseSong = async () => {
  const { data } = await request.get('/webapi/song/showcase')

  return data.value
}